<template>
    <section class="public_webinar_user_left_to_room_wrp">
        <div class="bg_wrapper_main">
            <div class="user_left_to_room">
                <div class="user_left_inner_wrp">
                    <h2>You left the room</h2>
                    <div class="user_left_btn">
                        <router-link :to="'/public/conference/' + this.hasGetFromRoute"
                            class="btn btn-primary mr-3">Rejoin</router-link>
                        <router-link class="btn btn-primary" :to="{ name: 'DashboardMain' }">Return to Home</router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
/*eslint-disable */
var $ = window.jQuery = require('jquery')
export default {
    name: 'public-video-conference-left-room',
    components: {},
    props: [],
    data() {
        return {
            hasGetFromRoute: ''
        }
    },
    computed: {

    },
    mounted() {
        this.hasGetFromRoute = this.$route.hash
    },
    methods: {

    },
    beforeCreate: function () {
        $('body').addClass('dashboard')
    },
    beforeRouteLeave: function (to, from, next) {
        $('body').removeClass('dashboard')
        next();
    },
}
</script>

<style lang="scss" scoped>
.public_webinar_user_left_to_room_wrp {
    padding: 75px 10px 10px;

    .bg_wrapper_main {
        background: rgba(0, 0, 0, 0.6);
        position: relative;
        width: 100%;
        border-radius: 3px;
        min-height: calc(100dvh - 85px);
    }

    .user_left_inner_wrp {
        background: rgba(0, 0, 0, 0.7);
        max-width: 400px;
        text-align: center;
        padding: 35px;
        border-radius: 5px;
        box-shadow: 3px 3px 3px rgba(255, 255, 255, 0.1), -3px -3px 3px rgba(255, 255, 255, 0.1);
        margin: 0 auto;
        width: 100%;
        font-family: 'lato', sans-serif;
    }

    .user_left_to_room {
        padding-top: 80px;
    }

    .user_left_inner_wrp h2 {
        font-size: 26px;
        font-weight: 600;
        color: #ffffc1;
        margin-bottom: 40px;
    }

    .user_left_btn .btn-primary {
        background: rgba(255, 255, 255, 0.1);
        border: none !important;
        color: #fff;
        padding: 5px 14px;
        display: inline-block;
        border-radius: 4px;
        font-size: 18px;
        outline: none !important;
        box-shadow: none !important;

        &:hover {
            background: #87cefa;
            color: #000;
        }
    }

    @media only screen and (max-width:767px) {
        .user_left_inner_wrp {
            padding: 15px;
        }
    }
}
</style>